// extracted by mini-css-extract-plugin
export default {"wrapper":"ResumePreview_wrapper__ycnrC","form":"ResumePreview_form__CpctW","preview":"ResumePreview_preview__Saqpb"};